let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1qLpu"), load("8qEcu"), load("bVl1P")]).then(() => parcelRequire('hnY2b'));